// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { EInitializationScope, EInitializeReportPolicy } from "@sequentech/ui-core";
/** The newest applicable published copy and current copy both impose requirements. */
export var initializesPerCountry = function (current, snapshots, electionId) {
    var _a;
    // The action returns newest targets first; older signed copies follow them.
    var published = snapshots.find(function (entry) { return entry.election_id === null || entry.election_id === electionId; });
    return (current === EInitializationScope.POST_AND_COUNTRY ||
        ((_a = published === null || published === void 0 ? void 0 : published.snapshot.policies) === null || _a === void 0 ? void 0 : _a.initialization_scope) === EInitializationScope.POST_AND_COUNTRY);
};
/** A required published report remains required until the approved publication changes it. */
export var effectiveInitializationReportPolicy = function (current, snapshots, electionId) {
    var _a;
    var published = snapshots.find(function (entry) { return entry.election_id === null || entry.election_id === electionId; });
    return current === EInitializeReportPolicy.REQUIRED ||
        ((_a = published === null || published === void 0 ? void 0 : published.snapshot.initialization_report_policies) === null || _a === void 0 ? void 0 : _a[electionId]) ===
            EInitializeReportPolicy.REQUIRED
        ? EInitializeReportPolicy.REQUIRED
        : current;
};
/** Match the backend: styled countries whose area or ancestor holds a Post contest. */
export var initializationCountries = function (data, electionId, snapshots) {
    var _a, _b;
    if (snapshots === void 0) { snapshots = []; }
    var areas = new Map(data.sequent_backend_area.map(function (area) { return [area.id, area]; }));
    var styled = new Set(data.sequent_backend_ballot_style.flatMap(function (style) { return (style.area_id ? [style.area_id] : []); }));
    var holdsContest = new Set(data.sequent_backend_area_contest
        .filter(function (link) { var _a; return ((_a = link.contest) === null || _a === void 0 ? void 0 : _a.election_id) === electionId; })
        .map(function (link) { return link.area_id; }));
    var published = snapshots.find(function (entry) { return entry.election_id === null || entry.election_id === electionId; });
    var retained = new Set((_b = (_a = published === null || published === void 0 ? void 0 : published.snapshot.initialization_countries) === null || _a === void 0 ? void 0 : _a[electionId]) !== null && _b !== void 0 ? _b : []);
    var current = data.sequent_backend_area.filter(function (area) {
        if (retained.has(area.id))
            return true;
        if (!styled.has(area.id))
            return false;
        var cursor = area;
        var seen = new Set();
        var matches = false;
        while (cursor) {
            if (seen.has(cursor.id))
                return false;
            seen.add(cursor.id);
            matches || (matches = holdsContest.has(cursor.id));
            if (!cursor.parent_id)
                return matches;
            cursor = areas.get(cursor.parent_id);
            if (!cursor)
                return false;
        }
        return false;
    });
    // A retained country still has a usable identifier when its current label is absent.
    for (var _i = 0, _c = Array.from(retained); _i < _c.length; _i++) {
        var id = _c[_i];
        if (!areas.has(id))
            current.push({ id: id, name: id });
    }
    return current;
};
/** Only an explicit eligible country produces a filter; whole-Post keeps the old request. */
export var initializationAreaIds = function (country, countries) {
    if (!countries.length)
        throw new Error("No eligible countries");
    if (!country)
        return undefined;
    if (!countries.some(function (area) { return area.id === country; }))
        throw new Error("Country is not eligible for this Post");
    return [country];
};
